enum ToastStatusEnum {
  Error = 'Error',
  Warning = 'Warning',
  Success = 'Success',
}

export default ToastStatusEnum;
